import React from "react";
import Modal, { ModalFooter } from "@amzn/meridian/modal";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import Text from "@amzn/meridian/text";
import { setUploadNewRevisionModalOpen } from "src/store/modelLifeCycleSlice";
import { useAppDispatch, useAppSelector } from "src/store/store";
import { uploadNewRevision } from "src/store/modelLifeCycleSlice";
import Column from "@amzn/meridian/column";

const UploadNewRevisionModal = () => {
  const dispatch = useAppDispatch();
  const { file, selectedUploadFileValues, preProcessUploadNewRevisionOutput } = useAppSelector(
    (state) => state.modelLifeCycleSlice,
  );
  const { selectedModelId } = useAppSelector((state) => state.modelSlice);
  const { uploadNewRevisionModalOpen } = useAppSelector((state) => state.modelLifeCycleSlice);

  const onClickFooterButton = () => {
    dispatch(setUploadNewRevisionModalOpen(false));
    dispatch(
      uploadNewRevision({
        modelId: selectedModelId,
        file: file!,
        groundTruthUploadFileValue: selectedUploadFileValues,
      }),
    );
  };
  const onCancel = () => {
    dispatch(setUploadNewRevisionModalOpen(false));
  };

  const textType = "h100";

  return (
    preProcessUploadNewRevisionOutput && (
      <Modal
        title="File Upload Modal"
        open={uploadNewRevisionModalOpen}
        width={600}
        onClose={onCancel}
        scrollContainer="viewport"
        closeLabel="Close"
      >
        <Column heights={["30%", "70%"]}>
          <Text>
            Your uploaded file contains the following information. Please click{" "}
            <b>Continue Upload</b> to proceed.
          </Text>
          <Row spacingInset={"100 400 100 100"} widths={"fill"}>
            <Column spacing={"300"} alignmentHorizontal="start">
              <Text>Total Rows in CSV Count:</Text>
              <Text>Existing Source Id Count:</Text>
              <Text>New Source Id Count:</Text>
              <Text>Invalid Rows Count:</Text>
            </Column>
            <Column spacing={"300"} alignmentHorizontal="end">
              <Text type={textType}>{preProcessUploadNewRevisionOutput.totalCount}</Text>
              <Text type={textType}>{preProcessUploadNewRevisionOutput.existingCount}</Text>
              <Text type={textType}>{preProcessUploadNewRevisionOutput.newCount}</Text>
              <Text type={textType}>{preProcessUploadNewRevisionOutput.inValidCount}</Text>
            </Column>
          </Row>
        </Column>

        <ModalFooter>
          <Row alignmentHorizontal="end" widths="fit">
            <Button type="primary" size="small" onClick={onClickFooterButton}>
              Continue Upload
            </Button>
          </Row>
        </ModalFooter>
      </Modal>
    )
  );
};

export default UploadNewRevisionModal;
